import {useState, useEffect} from 'react';
import { Box, Grid } from '@mui/material';
import { Header } from '../components/Header';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SchoolIcon from '@mui/icons-material/School';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CampaignIcon from '@mui/icons-material/Campaign';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import { useNavigate } from 'react-router-dom';
import { MenuButton } from '../components/Botones';
import { useTranslation } from 'react-i18next';
import useUserStore from '../store/UserStore';
import useSelectionsStore from '../store/UserSelectionsStore';
import { getNotifications } from '../services/getNotifications';
import STPOnlive from '../assets/STP Training onlive (1).png';
import CertificationsModal from '../components/CertificationsModal';
import ComingSoonModal from '../components/ComingSoonModal';

export function Home({ setIsAuthenticated }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useUserStore(state => state.user);
  const setSelections = useSelectionsStore(state => state.setSelections);
  const [unReadNotifications, setUnReadNotifications] = useState(false);
  const [certificationDialogOpen, setCertificationDialogOpen] = useState(false);
  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const [comingSoonMsg, setComingSoonMsg] = useState('');

  useEffect(() => {
    getNotifications(user.idpersona)
      .then((response) => {
        if (response.data.length > 0) {
          setUnReadNotifications(response.data.filter(notification => !notification.read).length > 9 ? '9+' : response.data.filter(notification => !notification.read).length); // If there are more than 9 unread notifications, display '9+' instead of the actual number
        }
      })
      .catch((error) => {
        console.error('Error fetching notifications:', error);
      });

    setSelections({ codeje: '', curso: '' });
  
  }, [user.idpersona]);

  const menuItems = [
    { icon: <EditCalendarIcon sx={{ color: 'white', fontSize: 40 }} />, label: t('home.menuItems.attendance'), route: '/attendance' },
    { icon: <SchoolIcon sx={{ color: 'white', fontSize: 40 }} />, label: t('home.menuItems.evaluation'), route: '/evaluation' },
    { icon: <AnnouncementIcon sx={{ color: 'white', fontSize: 40 }} />, label: t('home.menuItems.news'), route: '/news' },
    { icon: <ReceiptIcon sx={{ color: 'white', fontSize: 40 }} />, label: t('home.menuItems.receipts'), route: '/receipts' },
    { icon: <img src={STPOnlive} alt="Onlive" style={{ width: "100%" }} />, label: 'Onlive', onClick: () => { setComingSoonMsg(t('comingSoon.onliveMsg', 'Training Onlive estará disponible próximamente.')); setComingSoonOpen(true); } },
    { icon: <CampaignIcon sx={{ color: 'white', fontSize: 40 }} />, label: t('home.menuItems.communication'), route: '/communications', unReadNotifications: unReadNotifications },
    { icon: <MenuBookIcon sx={{ color: 'white', fontSize: 40 }} />, label: t('home.menuItems.recurseBank'), route: '/recursos' },
    { icon: <SchoolIcon sx={{ color: 'white', fontSize: 40 }} />, label: t('home.menuItems.certifications') || 'Certificacions', onClick: () => setCertificationDialogOpen(true) },
  ];

  const handleMenuButtonClick = (route) => {
    if (route === '/onlive') {
      window.location.href = 'https://trainingonlive.stptraining.es/';
      return;
    }
    navigate(route);
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      width: '100%',
    }}
    className="home"
    >
      <Header setIsAuthenticated={setIsAuthenticated}/>
      
      <Box sx={{ flexGrow: 1, padding: 3 }}>
        <Grid container spacing={2}>
          {menuItems.map((item, index) => (
            <Grid item xs={6} sm={3} key={index} onClick={() => item.onClick ? item.onClick() : handleMenuButtonClick(item.route)}>
              <MenuButton icon={item.icon} label={item.label} unReadNotifications={item.unReadNotifications}/>
            </Grid>
          ))}
        </Grid>
      </Box>
      <CertificationsModal open={certificationDialogOpen} onClose={() => setCertificationDialogOpen(false)} />
      <ComingSoonModal open={comingSoonOpen} onClose={() => setComingSoonOpen(false)} message={comingSoonMsg} />
    </Box>
  );
  
}
